import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {DataService} from '../../../../Services/data.service';
import {TransactionEntityService} from '../../../../Services/transaction-entity.service';
import {WoType, WoAsset, WoCategory} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-pm-schedule-form',
  templateUrl: './pm-schedule-form.component.html',
  standalone: false,
})
export class PmScheduleFormComponent implements OnInit {

  scheduleId: string | null = null;
  isLoaded = false;
  saving = false;
  form: UntypedFormGroup;
  entities: any[] = [];
  assets: WoAsset[] = [];
  woTypes: WoType[] = [];
  woCategories: WoCategory[] = [];
  checklistTemplates: any[] = [];
  users: any[] = [];
  locations: any[] = [];
  addresses: any[] = [];
  contacts: any[] = [];
  frequencies = ['daily', 'weekly', 'monthly', 'quarterly', 'annually'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private fb: UntypedFormBuilder,
    private woService: WorkOrderService,
    private dataService: DataService,
    private entityService: TransactionEntityService,
    private notification: BsToastService,
  ) {
    this.form = this.fb.group({
      entity_id: [null, Validators.required],
      asset_id: [null],
      company_id: [null],
      type_id: [null, Validators.required],
      description: ['', Validators.required],
      frequency: ['monthly', Validators.required],
      frequency_interval: [1, [Validators.required, Validators.min(1)]],
      next_due_date: [null, Validators.required],
      assigned_user_id: [null],
      location_id: [null],
      address_id: [null],
      contact_id: [null],
      category_id: [null],
      checklist_id: [null],
      estimated_hours: [null],
      active: [true],
    });
  }

  ngOnInit(): void {
    this.scheduleId = this.route.snapshot.queryParamMap.get('id');
    this.dataService.getDataWithParams('entity', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => this.entities = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    this.dataService.getDataWithParams('location', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => this.locations = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    this.dataService.getDataWithParams('sys_user', 'pageNumber=0&pageSize=999999').subscribe({
      next: (r: any) => this.users = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    this.woService.getWoTypes().subscribe({
      next: r => this.woTypes = r, error: () => {
      }
    });
    this.woService.getWoCategories().subscribe({
      next: (r: any) => this.woCategories = r?.Data ?? r?.data ?? r ?? [], error: () => {
      }
    });
    this.woService.getChecklistTemplates().subscribe({
      next: (r: any) => this.checklistTemplates = r?.Data ?? r?.data ?? r ?? [], error: () => {
      }
    });
    this.woService.getAssets().subscribe({
      next: r => this.assets = r, error: () => {
      }
    });
    if (this.scheduleId) {
      this.woService.getPmSchedule(this.scheduleId).subscribe({
        next: (res) => {
          this.form.patchValue(res);
          if (res?.entity_id) {
            this.onEntityChange(res.entity_id);
          }
          this.isLoaded = true;
        },
        error: () => {
          this.notification.showErrorToast('Error loading schedule.');
          this.isLoaded = true;
        }
      });
    } else {
      this.isLoaded = true;
    }
  }

  onEntityChange(entityId: string): void {
    if (!entityId) {
      this.addresses = [];
      this.contacts = [];
      return;
    }
    this.entityService.loadEntityAddresses(entityId).subscribe({
      next: (r: any) => this.addresses = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
    this.entityService.loadEntityContacts(entityId).subscribe({
      next: (r: any) => this.contacts = r?.Data ?? r?.data ?? r ?? [],
      error: () => {
      }
    });
  }

  save(): void {
    if (this.saving) {
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const body = this.form.getRawValue();
    console.log('[PM Schedule Save] payload:', body);
    const obs = this.scheduleId
      ? this.woService.updatePmSchedule(this.scheduleId, body)
      : this.woService.createPmSchedule(body);
    obs.subscribe({
      next: (res: any) => {
        this.saving = false;
        if (!this.scheduleId) {
          const newId = res?.id ?? res?.schedule?.id;
          if (newId) {
            this.scheduleId = newId;
            const url = this.router.createUrlTree([], {
              relativeTo: this.route,
              queryParams: {id: newId},
              queryParamsHandling: 'merge',
            }).toString();
            this.location.replaceState(url);
          }
        }
      },
      error: () => {
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/work-orders/pm-schedules/pm-schedule-list']);
  }
}
